<template>
    <Modal>
        <div v-if="passwordChanged" class="text-center font-italic pt-5">{{ $t('passwordChanged') }}</div>
        <form v-else @submit="submitPasswordChanged" method="post" class="m-4">
            <div v-if="this.$route.query.show_warning" class="row mb-4 text-center">
                <span v-html="this.$t('considerChangingPassword')"/>
            </div>

            <div v-if="loading" class="row justify-content-center position-absolute pt-5" style="left: 0; right: 0">
                <div
                        class="spinner-border"
                        role="status"
                        style="width: 10rem; height: 10rem; z-index: 1"
                ></div>
            </div>

            <div class="row justify-content-center py-4">
                <label for="username" class="sr-only">
                    Username
                </label>
                <input
                        type="text"
                        id="username"
                        autocomplete="off"
                        class="form-control form-control-lg col"
                        :disabled="loading"
                        v-model="username"
                        :placeholder="this.$t('username')"
                >
            </div>

            <div class="row justify-content-center py-4">
                <label for="currentPassword" class="sr-only">
                    Current Password
                </label>
                <input
                        type="password"
                        id="currentPassword"
                        autocomplete="off"
                        class="form-control form-control-lg col"
                        :disabled="loading"
                        v-model="currentPassword"
                        :placeholder="this.$t('currentPassword')"
                >
            </div>

            <div class="row justify-content-center py-4">
                <label for="newPassword" class="sr-only">
                    New Password
                </label>
                <input
                        type="password"
                        id="newPassword"
                        autocomplete="off"
                        class="form-control form-control-lg col"
                        :disabled="loading"
                        v-model="newPassword"
                        :placeholder="this.$t('newPassword')"
                >
            </div>

            <div class="row justify-content-center py-4">
                <label for="newPasswordRepeated" class="sr-only">
                    New Password
                </label>
                <input
                        type="password"
                        id="newPasswordRepeated"
                        autocomplete="off"
                        class="form-control form-control-lg col"
                        :disabled="loading"
                        v-model="newPasswordRepeated"
                        :placeholder="this.$t('newPasswordRepeat')"
                >
            </div>

            <div class="row py-4">
                <div class="text-danger font-italic" v-for="error in errors" :key="error.code">
                    {{ $t(error.code) }}
                </div>
            </div>

            <div class="row justify-content-end align-items-center py-4">
                <button
                        type="submit"
                        id="login"
                        :disabled="this.newPasswordNotRepeated"
                        class="btn btn-primary col-6">
                    {{ $t('change') }}
                </button>
            </div>
        </form>
    </Modal>
</template>

<script>
    import jwtDecode from "jwt-decode";
    import Modal from "../Shared/Modal";
    import axios from "axios";

    export default {
        components: {
            Modal
        },
        data() {
            return {
                loading: false,
                errors: [],
                currentPassword: "",
                passwordChanged: false,
                username: this.tryDeductUsername(),
                newPassword: "",
                newPasswordRepeated: ""
            };
        },
        created() {
            this.submitPasswordChanged();
        },
        methods: {
            tryDeductUsername: function () {

                if (this.$route.query.username) {
                    return this.$route.query.username;
                }

                const token = localStorage.getItem('access_token');

                if (token) {
                    return jwtDecode(token).username;
                }
            },
            submitPasswordChanged: function (event) {
                event && event.preventDefault();

                this.loading = true;

                const passwordChangeRequest = {
                    username: this.username,
                    password: this.currentPassword,
                    newPassword: this.newPassword
                };

                axios.put("/api/v4/auth", passwordChangeRequest)
                    .then(() => {
                        this.passwordChanged = true;
                        setTimeout(() => this.$router.push('/login'), 5000);
                    })
                    .catch(errorResponse => {
                        this.errors = errorResponse.response.data;
                    })
                    .then(() => this.loading = false);
            }
        },
        computed: {
            newPasswordNotRepeated() {
                return !this.newPassword || !this.newPasswordRepeated || this.newPassword !== this.newPasswordRepeated;
            },
            errorMessage() {
                return this.error;
            }
        }
    }
</script>

<style lang="scss">
    @import '~bootstrap/scss/bootstrap';
</style>

<i18n lang="yaml" locale="en">
    passwordChanged: "Password changed successfully. You will now be redirected to the login page..."
    considerChangingPassword: "<i>We have updated our password security policy. For your own safety, you need to change
    your password.</i>"
    currentPassword: "Current Password"
    newPassword: "New Password"
    newPasswordRepeat: "New Password (Again)"
</i18n>

<i18n lang="yaml" locale="dk">
    passwordChanged: "Adgangskoden blev ændret. Du bliver nu omdirigeret til login-siden..."
    considerChangingPassword: "<i>Vi har opdateret sikkerheden omkring adgangskoder. For en sikkerheds skyld beder vi
    dig om at ændre din adgangskode.</i>"
    currentPassword: "Nuværende adgangskode"
    newPassword: "Ny Adgangskode"
    newPasswordRepeat: "Ny Adgangskode (Igen)"
</i18n>
